import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';

export const mobileRedirectGuard: CanActivateFn = (route, state): boolean => {
  const deviceService = inject(DeviceDetectorService);
  const router = inject(Router);

  // Check if user is on mobile and not already on download-app page
  if (
    deviceService.isMobile() &&
    !(state.url.includes('/download-app') || state.url.includes('/openinapp'))
  ) {
    // Navigate to download-app page using router
    router.navigate(['/download-app'], { replaceUrl: true });
    return false; // Prevent navigation to current route
  }

  return true;
};
